/* tslint:disable */
/* eslint-disable */
export enum BehaviorGraphType {
  Frequency = 0,
  DurationTotal = 1,
  DurationAverage = 2,
  TimeOfDay = 3,
  AntecedentsForBehavior = 4,
  ConsequencesForBehavior = 5,
  LocationsForBehavior = 6,
  ResponseForBehavior = 7,
  SeverityForBehavior = 8,
  FrequencyForAntecedents = 9,
  FrequencyForConsequences = 10,
  FrequencyForLocations = 11,
  FrequencyForResponses = 12,
  FrequencyForSeverities = 13,
  IntervalPercentageHappened = 14,
  IntervalPercentageNotHappened = 15,
  DurationByTrial = 16,
  RateTimerLine = 17
}
